import {v4 as uuid} from 'uuid'
import eio from 'engine.io-client'
import getJwt from './auth-iframe'

export default class ClientSocketConnection {
  constructor(url) {
    this.url = url
    this.requestDeferreds = {}
    this.sendQueue = []
    this.openSocket()
  }

  get delay() {
    return 1000 + 1000 * this.openFails
  }

  openSocket() {
    this.openFails = this.openFails || 0
    this.socket = eio(this.url)

    const openTimeout = setTimeout(() => {
      this.openFails++
      if (this.socket) this.socket.close()
    }, this.delay)

    this.socket.on('close', () => {
      this.socket = null
      setTimeout(() => this.openSocket(), this.delay)
    })

    this.socket.on('open', () => {
      this.openFails = 0
      clearTimeout(openTimeout)
    })

    this.socket.on('message', data => this.onMessage(JSON.parse(data)))
  }

  request(type, body={}) {
    const requestId = uuid()
    const deferred = this.requestDeferreds[requestId] = {}

    return new Promise((resolve, reject) => {
      deferred.resolve = resolve
      deferred.reject = reject
      this.sendMessage(`REQUEST:${type}`, {requestId, body})
    })
  }

  onMessage(msg) {
    if (/^RESPONSE:/.test(msg.type)) {
      const deferred = this.requestDeferreds[msg.requestId]
      if (deferred) return deferred.resolve(msg.payload)
    }
  }

  async sendMessage(type, content={}) {
    content = JSON.parse(JSON.stringify(content))// copy content in case it's mutated before sending

    this.sendQueue.push({date: new Date(), type, content})
    if (this.sendQueue.length > 1) return

    let jwt
    while (!this.socket || this.socket.readyState !== 'open' || !(jwt = getJwt())) {
      await new Promise(resolve => setTimeout(resolve, 1000))
    }

    for (const {date, type, content} of this.sendQueue) {
      const msg = {jwt, date, type, content}
      try {
        this.socket.send(JSON.stringify(msg))
      } catch (err) {
        console.log('Error sending message:', msg)
        console.log(err.stack)
      }
    }

    this.sendQueue = []
  }
}
